export default __webpack_public_path__ + "f418f8c0eebbdb722e09625188dbd5a1.png";